import React from 'react';
import ScenarioManager from '../components/Scenarios/ScenarioManager';

const ScenariosPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Scenario Management</h1>
        <p className="text-gray-600 mt-2">
          Save, load, and compare different workforce planning scenarios
        </p>
      </div>

      <ScenarioManager />
    </div>
  );
};

export default ScenariosPage;
